import { HttpRequest } from './HttpRequest'

export const GetMasterDataVlookupByType = async (type: 'OB_Payment' | 'TransferType' | 'TransferPlan_Operation' | 'TransferPlan_Type' | 'InspectionTransfer' | 'TransferPlan_EmailTrans' | 'BankReason') => {
    try { 
        const response = await HttpRequest().get(`/masterdata/vlookup/type/${type}`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result
        }
        return []
    } catch (error: any) {
        return []
    }
}

export const GetMasterDataByType = async (type: 'ContractStatus' | 'ReceivePromotion' | 'JoinEvent' | 'PurposeOfBuy'| 'AppointmentStatus' | 'TransferStatus'| 'PayStatusType' | 'PayStatus_CusOverPayType' ) => {
    try { 
        const response = await HttpRequest().get(`/masterdata/type/${type}`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result
        }
        return []
    } catch (error: any) {
        return []
    }
}

export const GetMasterDataVlookUptpl1ByType = async (type: 'CreditStatus') => {
    try { 
        const response = await HttpRequest().get(`/masterdata/vlookuptpl1/type/${type}`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result
        }
        return []
    } catch (error: any) {
        return []
    }
}

export const GetMasterDataBank = async () => {
    try {
        const response = await HttpRequest().get(`/masterdata/bank`)
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    } catch (error: any) {
        return []
    }
}

export const GetMasterDataCreditReasonStatusByCreditStatusId = async (creditStatusId: number) => {
    try {
        const response = await HttpRequest().get(`/masterdata/vlookuptpl2/creditstatusid/${creditStatusId}`)
        
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    }  catch (error: any) {
        return []
    }
}

export const GetMasterTitle = async () => {
    try {
        const response = await HttpRequest().get(`/masterdata/title`)
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    }  catch (error) {
        return []
    }
}

export const GetMaritalStatus = async () => {
    try {
        const response = await HttpRequest().get(`/masterdata/maritalstatus`)
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    }  catch (error) {
        return []
    }
}

export const GetNationality = async () => {
    try {
        const response = await HttpRequest().get(`/masterdata/nationality`)
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    }  catch (error) {
        return []
    }
}

export const GetRace = async () => {
    try {
        const response = await HttpRequest().get(`/masterdata/race`)
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    }  catch (error) {
        return []
    }
}

export const GetCountry = async () => {
    try {
        const response = await HttpRequest().get(`/masterdata/country`)
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    }  catch (error) {
        return []
    }
}

export const GetProjectZone = async () => {
    try {
        const response = await HttpRequest().get(`/masterdata/projectzone`)
        if (response.data.message === 'OK') {
            const result = response.data.responseData
            return result
        }
    }  catch (error) {
        return []
    }
}